// The moment a call ends: what the account stream just closed, shown once over the page.

import type { Play } from "./record";
import { createStore } from "./store";

export type Moment = { key: number; plays: Play[]; streak: number };

export const moment = createStore<Moment | null>(null);

let next = 1;

export function showMoment(plays: Play[], streak: number) {
  if (plays.length === 0) return;
  moment.set({ key: next++, plays, streak });
}

export function dismissMoment(key: number) {
  moment.set((held) => (held?.key === key ? null : held));
}
